import axios from "axios";
import Util from "services/Util";
import pathAfterLogin from "services/pathAfterLogin";

const SSO_PATH_TOKEN_REGEX = /^\/sso\/(\d+)\/(\d+)\/([^/]+)\/?$/;

const SSO_AUDIENCE_ROUTES = {
  feed: 'home',
  quizplus: 'quiz',
  links: 'home',
};

class SSOService {
  mapAudienceToRoute(redirectTo) {
    if (!redirectTo) {
      return redirectTo;
    }

    const audience = redirectTo.trim().toLowerCase().replace(/^\/+|\/+$/g, '');

    return SSO_AUDIENCE_ROUTES[audience] || redirectTo;
  }

  isSsoLoginPath(pathname) {
    return pathname === '/sso' || SSO_PATH_TOKEN_REGEX.test(pathname || '');
  }

  parseSsoLoginParams({ pathname, search } = window.location) {
    const params = new URLSearchParams(search);
    const redirectTo = this.mapAudienceToRoute(params.get('redirectTo'));
    const hashFromQuery = params.get('hash');

    if (hashFromQuery) {
      return { hash: hashFromQuery, redirectTo };
    }

    const match = (pathname || '').match(SSO_PATH_TOKEN_REGEX);
    if (match) {
      const [, teamId, userId, token] = match;
      return { hash: `${teamId}-${userId}-${token}`, redirectTo };
    }

    return null;
  }

  getSSOBaseUrl() {
    const util = new Util();
    const subdomain = util.getSubDomain();

    if (subdomain === "dev") {
      return "http://localhost:8000";
    }

    try {
      const config = JSON.parse(localStorage.getItem('@beedooconfigkey')) || {};
      const { whitelabelBaseDomain, isWhiteLabel } = config;
      const baseDomain = isWhiteLabel && whitelabelBaseDomain ? whitelabelBaseDomain : 'beedoo.io';
      return `https://${subdomain}-sso.${baseDomain}`;
    } catch {
      return `https://${subdomain}-sso.beedoo.io`;
    }
  }

  encodeCallbackQuery(queryParams) {
    if (!queryParams || Object.keys(queryParams).length === 0) {
      return '';
    }

    const queryString = new URLSearchParams(queryParams).toString();
    const encoded = btoa(queryString);

    return `?callback=${encodeURIComponent(encoded)}`;
  }

  buildCallbackQuery({ mobileCallback, redirectTo } = {}) {
    const payload = {};

    if (mobileCallback) {
      payload.mobileCallback = mobileCallback;
    }

    const resolvedRedirectTo = redirectTo !== undefined
      ? redirectTo
      : pathAfterLogin.getPathForSsoRedirect();

    if (resolvedRedirectTo) {
      payload.redirectTo = resolvedRedirectTo;
    }

    return this.encodeCallbackQuery(payload);
  }

  async getApplications(provider) {
    try {
      const util = new Util();
      const subdomain = util.getSubDomain();
      const ssoBaseUrl = this.getSSOBaseUrl();

      const response = await axios.get(`${ssoBaseUrl}/api/registered-applications/${subdomain}/${provider}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching SSO applications:', error);
      return { registered: [], icon: null };
    }
  }
}

export default new SSOService();
